import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CONSTANTS from "../utils/constants";

export default function Comment() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [comments, setComments] = useState([]);
  const [error, setError] = useState(null);
  const [isCommentActive, setIsCommentActive] = useState(true);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setError(null);
      setLoading(true);

      // Şimdilik aktif varsayılıyor (backend bağlanabilir)
      let isActiveFromServer = true;
      setIsCommentActive(isActiveFromServer);

      if (isActiveFromServer) {
        const res = await fetch(`${CONSTANTS.baseRoute}/comments`);
        if (!res.ok) {
          throw new Error(t("comments.fetchError"));
        }

        const data = await res.json();
        if (data.success) {
          setComments(data.comments || []);
        } else {
          setError(data.error || t("comments.fetchError"));
        }
      } else {
        setComments([]);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || t("common.error"));
      setComments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      setError(null);
      const res = await fetch(`${CONSTANTS.baseRoute}/comments/${id}`, {
        method: "DELETE"
      });

      if (!res.ok) throw new Error(t("comments.deleteError"));

      const data = await res.json();
      if (data.success) {
        setComments(prev => prev.filter(c => c.id !== id));
      } else {
        setError(data.error || t("comments.deleteError"));
      }
    } catch (err) {
      setError(err.message || t("comments.deleteError"));
    }
  };

  const getRatingBadgeColor = (rating) => {
    if (rating >= 4) return "bg-success";
    if (rating >= 3) return "bg-warning text-dark";
    return "bg-danger";
  };

  if (loading) {
    return (
      <div className="admin-main ps-2 pe-3 py-2">
        <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">{t("common.loading")}</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-main ps-2 pe-3 py-2">
        <div className="alert alert-danger d-flex justify-content-between align-items-center">
          <span>{t("common.error")}: {error}</span>
          <button className="btn btn-outline-danger btn-sm" onClick={fetchData}>
            {t("common.retry")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-main ps-2 pe-3 py-2">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex gap-2 align-items-center">
          <button className="btn btn-light" onClick={() => navigate(-1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button className="btn btn-light" onClick={() => navigate(+1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <h5 className="fw-bold m-0">{t("comments.title")}</h5>
        </div>
      </div>

      {isCommentActive ? (
        comments.length > 0 ? (
          comments.map(comment => (
            <div key={comment.id} className="card mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <h5>{comment.name}</h5>
                  <span className={`badge ${getRatingBadgeColor(comment.rating)} p-2`}>
                    {t("comments.rating")}: {comment.rating} / 5
                  </span>
                </div>

                <p className="mt-2">{comment.comment}</p>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <small className="text-muted">
                    {new Date(comment.created_at).toLocaleString()}
                  </small>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(comment.id)}
                  >
                    <i className="bi bi-trash"></i> {t("comments.delete")}
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="alert alert-info mt-3">
            <i className="bi bi-info-circle"></i>{" "}
            {t("comments.empty")}
          </div>
        )
      ) : (
        <div className="alert alert-warning mt-3">
          <i className="bi bi-exclamation-triangle"></i>{" "}
          {t("comments.disabled")}
        </div>
      )}
    </div>
  );
}
